import { PolicyPdfData } from "../policyPdf/PolicyPdf.types";

export enum PublicPolicyAcknowledgementState {
    Ready = 0,
    NotFound = 1,
    AlreadyAcknowledged = 2,
}

export interface PublicPolicyAcknowledgementViewModel {
    state: PublicPolicyAcknowledgementState;
    acknowledgedAt: string | null;
    policyData: PolicyPdfData | null;
    emailLogoBlobId: string | null;
}
